import { useMemo, useState } from 'react';
import KotOutletMaster from './KotOutletMaster';
import KotKitchenStationMaster from './KotKitchenStationMaster';
import KotTableMaster from './KotTableMaster';
import KotFoodTypeMaster from './KotFoodTypeMaster';
import KotFoodCategoryMaster from './KotFoodCategoryMaster';
import KotItemMaster from './KotItemMaster';
import KotTimeSlotMaster from './KotTimeSlotMaster';
import KotMealPeriodMaster from './KotMealPeriodMaster';
import KotPricingProfileMaster from './KotPricingProfileMaster';
import KotMenuTypeMaster from './KotMenuTypeMaster';
import KotMenuCategoryMaster from './KotMenuCategoryMaster';
import KotTaxProfileMaster from './KotTaxProfileMaster';
import KotOfferMaster from './KotOfferMaster';

function KotMastersHub({ token, selectedProperty, onOutletChanged }) {
  const tabs = useMemo(() => ([
    { key: 'outlet', label: 'Outlet', render: () => <KotOutletMaster token={token} selectedProperty={selectedProperty} onOutletChanged={onOutletChanged} /> },
    { key: 'station', label: 'Kitchen Station', render: () => <KotKitchenStationMaster token={token} selectedProperty={selectedProperty} /> },
    { key: 'table', label: 'Table', render: () => <KotTableMaster token={token} selectedProperty={selectedProperty} /> },
    { key: 'food-type', label: 'Food Type', render: () => <KotFoodTypeMaster token={token} selectedProperty={selectedProperty} /> },
    { key: 'food-category', label: 'Food Category', render: () => <KotFoodCategoryMaster token={token} selectedProperty={selectedProperty} /> },
    { key: 'item', label: 'Item', render: () => <KotItemMaster token={token} selectedProperty={selectedProperty} /> },
    { key: 'slot', label: 'Time Slot', render: () => <KotTimeSlotMaster token={token} selectedProperty={selectedProperty} /> },
    { key: 'meal-period', label: 'Meal Period Configuration', render: () => <KotMealPeriodMaster token={token} selectedProperty={selectedProperty} /> },
    { key: 'pricing', label: 'Pricing Profile', render: () => <KotPricingProfileMaster token={token} selectedProperty={selectedProperty} /> },
    { key: 'tax-profile', label: 'Tax Profile', render: () => <KotTaxProfileMaster token={token} selectedProperty={selectedProperty} /> },
    { key: 'menu-type', label: 'Menu Type', render: () => <KotMenuTypeMaster token={token} selectedProperty={selectedProperty} /> },
    { key: 'menu-category', label: 'Menu Category', render: () => <KotMenuCategoryMaster token={token} selectedProperty={selectedProperty} /> },
    { key: 'offer', label: 'Offers', render: () => <KotOfferMaster token={token} selectedProperty={selectedProperty} /> }
  ]), [token, selectedProperty, onOutletChanged]);

  const [activeTab, setActiveTab] = useState('outlet');
  const currentTab = tabs.find((t) => t.key === activeTab) || tabs[0];

  return (
    <div className="page-shell">
      <h2 style={{ color: '#1f8f4d', marginBottom: '0.75rem' }}>KOT & POS - Masters</h2>
      <div style={{ display: 'flex', gap: '0.45rem', flexWrap: 'wrap', borderBottom: '1px solid #dcdde1', paddingBottom: '0.55rem', marginBottom: '0.8rem' }}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '0.42rem 0.8rem',
              borderRadius: '6px',
              border: '1px solid #dcdde1',
              cursor: 'pointer',
              background: tab.key === currentTab.key ? 'var(--theme-accent)' : '#fff',
              color: tab.key === currentTab.key ? '#fff' : '#1f8f4d',
              fontWeight: 700
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div>{currentTab.render()}</div>
    </div>
  );
}

export default KotMastersHub;
